import { render, staticRenderFns } from "./Tarifs2Roues.vue?vue&type=template&id=0c570b7e&scoped=true&"
import script from "./Tarifs2Roues.vue?vue&type=script&lang=js&"
export * from "./Tarifs2Roues.vue?vue&type=script&lang=js&"
import style0 from "./Tarifs2Roues.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Tarifs2Roues.vue?vue&type=style&index=1&id=0c570b7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c570b7e",
  null
  
)

export default component.exports